import get from 'lodash.get';

import { createDeepEqualSelector } from '../../../../redux/utils/selectors';
import { selectCardLastDigits, selectCardExpMonth, selectCardExpYear } from '../../../../redux/auth/billing/selectors';
import * as fmt from '../../../../utils/formatters';

import {
  BILLING_CYCLE_MONTHLY,
  BILLING_CYCLE_YEARLY,
  PRODUCT_PROFESSIONAL_PRICES,
} from '../../../../constants/payment';

const selectBillingCycle = (_, props) => props.billingCycle;

export const selectPrice = createDeepEqualSelector([selectBillingCycle], (billingCycle) => {
  const p = get(PRODUCT_PROFESSIONAL_PRICES, billingCycle);

  if (billingCycle === BILLING_CYCLE_YEARLY) {
    const price = fmt.currencyUSD(p * 12);

    return `${price}/year ($${p} × 12)`;
  }

  if (billingCycle === BILLING_CYCLE_MONTHLY) {
    const price = fmt.currencyUSD(p);

    return `${price}/month`;
  }

  return `-`;
});

export const selectIsCardDataEmpty = createDeepEqualSelector(
  [selectCardLastDigits, selectCardExpMonth, selectCardExpYear],
  (cardDigits, cardExpMonth, cardExpYear) => !cardDigits && !cardExpMonth && !cardExpYear,
);
